export default __webpack_public_path__ + "static/media/webBanner1.2b59e57b.png";